// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"282f1f96f68b6626caaa","258":"f33d9342c2b4ab2cc9d3"}[chunkId] + ".js";
};